import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// Root Singleton Services
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { select, Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import * as fromAuth from 'app/auth/store';
import { LoginResponseObj } from '../../domain/loginResponseObj';
import { SessionStorageService } from 'app/core/services/sessionStorage.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  currentUser: LoginResponseObj;
  userObjectKey = 'userObject';

  constructor(
    private router: Router,
    private sessionStorage: SessionStorageService,
    public snackbar: MatSnackBar,
    private store: Store<fromRoot.AppState>
  ) {
    const userObject = new LoginResponseObj();
    const sessionStorageItem = this.sessionStorage.get(this.userObjectKey);
    this.currentUser = userObject.parseFromSessionStorage(sessionStorageItem);
  }

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.isAdminOrEboAdmin),
      first(),
      tap(isAdmin => {
        if (!isAdmin) {
          this.router.navigate(['/settings/view']);
          this.snackbar.open(`Forbidden: You don't have access to this page.`, 'Dismiss', { duration: 3000 });
        }
      })
    );
  }
}
